// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Card shell ───────────────────────────────────────────────────────────── */

.scl--cms-components-careerChart-card {
  position: relative;
  width: 581px;
  height: 364px;
  background: var(--neutralcolors-100);
  box-shadow: 0px 1px 4px rgba(25, 33, 61, 0.08);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

/* ── Header ───────────────────────────────────────────────────────────────── */

.scl--cms-components-careerChart-header {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 20px;
  height: 56px;
  border-bottom: 1px solid var(--neutralcolors-400);
  border-radius: 5px 5px 0 0;
  flex-shrink: 0;
}

.scl--cms-components-careerChart-title {
  background: none;
  border: none;
  padding: 5px 20px 5px 0px;
  cursor: pointer;
  font-family: var(--font-family-inter), sans-serif;
  font-weight: 600;
  font-size: var(--font-size-18);
  line-height: var(--line-height-24);
  letter-spacing: -0.01em;
  color: var(--typography-text-body-primary);
  text-align: left;
  text-decoration: none;
}

.scl--cms-components-careerChart-title:hover {
  text-decoration: underline;
}

.scl--cms-components-careerChart-dotsBtn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

/* ── Chart body ───────────────────────────────────────────────────────────── */

.scl--cms-components-careerChart-body {
  display: flex;
  flex-direction: row;
  padding: 17px 24px;
  flex: 1;
  gap: 8px;
  min-height: 0;
  overflow: visible;
}

/* ── Y-axis ───────────────────────────────────────────────────────────────── */

.scl--cms-components-careerChart-yAxis {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 28px;
  flex-shrink: 0;
  width: 22px;
}

.scl--cms-components-careerChart-yLabel {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-18);
  color: var(--typography-text-body-secondary);
  text-align: right;
}

/* ── Bars area ────────────────────────────────────────────────────────────── */

.scl--cms-components-careerChart-barsArea {
  flex: 1;
  position: relative;
  min-height: 0;
  overflow: visible;
}

/* Grid lines */

.scl--cms-components-careerChart-gridLines {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 28px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
}

.scl--cms-components-careerChart-gridLine {
  width: 100%;
  height: 1px;
  border-top: 1px dashed var(--neutralcolors-400);
}

/* ── Bars ─────────────────────────────────────────────────────────────────── */

.scl--cms-components-careerChart-bars {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-around;
  padding-bottom: 5px;
}

.scl--cms-components-careerChart-barCol {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  height: 100%;
  flex: 1;
  cursor: default;
}

.scl--cms-components-careerChart-barWrap {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  width: 46px;
  position: relative;
  overflow: visible;
  border-radius: 8px;
  z-index: 0;
}

.scl--cms-components-careerChart-barEmpty {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 30px;
  width: 46px;
  height: 100%;
  border-radius: 8px;
  background-size: cover;
  background-repeat: repeat;
  z-index: 0;
}

.scl--cms-components-careerChart-barFill {
  width: 46px;
  border-radius: 8px;
  flex-shrink: 0;
  z-index: 1;
  position: relative;
}

/* X-axis label */

.scl--cms-components-careerChart-barLabel {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-18);
  color: var(--typography-text-body-secondary);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90px;
  flex-shrink: 0;
}

/* ── Tooltip ──────────────────────────────────────────────────────────────── */

.scl--cms-components-careerChart-tooltip {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: var(--neutralcolors-100);
  border: 0.735px solid var(--neutralcolors-400);
  box-shadow: 0px 0.735px 2.94px rgba(25, 33, 61, 0.08);
  border-radius: 3px;
  padding: 5px 8px;

  font-family: var(--font-family-inter), sans-serif;
  font-weight: 600;
  font-size: 10.3px;
  line-height: 15px;
  color: var(--neutralcolors-700);
  white-space: nowrap;
  pointer-events: none;
}

.scl--cms-components-careerChart-tooltipBeak {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid var(--neutralcolors-400);
}

.scl--cms-components-careerChart-tooltipBeak::after {
  content: '';
  position: absolute;
  top: -7px;
  left: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--neutralcolors-100);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/career-dsb-op/career-chart/css/careerChart.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;EACjD,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,iBAAiB;AACnB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA,gFAAgF;;AAEhF;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA,eAAe;;AAEf;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+CAA+C;AACjD;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA,iBAAiB;;AAEjB;EACE,iDAAiD;EACjD,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;;EAEX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,oCAAoC;EACpC,8CAA8C;EAC9C,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;;EAEhB,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;AAChD","sourcesContent":["/* ── Card shell ───────────────────────────────────────────────────────────── */\n\n.scl--cms-components-careerChart-card {\n  position: relative;\n  width: 581px;\n  height: 364px;\n  background: var(--neutralcolors-100);\n  box-shadow: 0px 1px 4px rgba(25, 33, 61, 0.08);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n}\n\n/* ── Header ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-careerChart-header {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 20px;\n  height: 56px;\n  border-bottom: 1px solid var(--neutralcolors-400);\n  border-radius: 5px 5px 0 0;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-careerChart-title {\n  background: none;\n  border: none;\n  padding: 5px 20px 5px 0px;\n  cursor: pointer;\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: 600;\n  font-size: var(--font-size-18);\n  line-height: var(--line-height-24);\n  letter-spacing: -0.01em;\n  color: var(--typography-text-body-primary);\n  text-align: left;\n  text-decoration: none;\n}\n\n.scl--cms-components-careerChart-title:hover {\n  text-decoration: underline;\n}\n\n.scl--cms-components-careerChart-dotsBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n/* ── Chart body ───────────────────────────────────────────────────────────── */\n\n.scl--cms-components-careerChart-body {\n  display: flex;\n  flex-direction: row;\n  padding: 17px 24px;\n  flex: 1;\n  gap: 8px;\n  min-height: 0;\n  overflow: visible;\n}\n\n/* ── Y-axis ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-careerChart-yAxis {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding-bottom: 28px;\n  flex-shrink: 0;\n  width: 22px;\n}\n\n.scl--cms-components-careerChart-yLabel {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-18);\n  color: var(--typography-text-body-secondary);\n  text-align: right;\n}\n\n/* ── Bars area ────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-careerChart-barsArea {\n  flex: 1;\n  position: relative;\n  min-height: 0;\n  overflow: visible;\n}\n\n/* Grid lines */\n\n.scl--cms-components-careerChart-gridLines {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 28px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  pointer-events: none;\n}\n\n.scl--cms-components-careerChart-gridLine {\n  width: 100%;\n  height: 1px;\n  border-top: 1px dashed var(--neutralcolors-400);\n}\n\n/* ── Bars ─────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-careerChart-bars {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: space-around;\n  padding-bottom: 5px;\n}\n\n.scl--cms-components-careerChart-barCol {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  height: 100%;\n  flex: 1;\n  cursor: default;\n}\n\n.scl--cms-components-careerChart-barWrap {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 1;\n  width: 46px;\n  position: relative;\n  overflow: visible;\n  border-radius: 8px;\n  z-index: 0;\n}\n\n.scl--cms-components-careerChart-barEmpty {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 30px;\n  width: 46px;\n  height: 100%;\n  border-radius: 8px;\n  background-size: cover;\n  background-repeat: repeat;\n  z-index: 0;\n}\n\n.scl--cms-components-careerChart-barFill {\n  width: 46px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  z-index: 1;\n  position: relative;\n}\n\n/* X-axis label */\n\n.scl--cms-components-careerChart-barLabel {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-18);\n  color: var(--typography-text-body-secondary);\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 90px;\n  flex-shrink: 0;\n}\n\n/* ── Tooltip ──────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-careerChart-tooltip {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  background: var(--neutralcolors-100);\n  border: 0.735px solid var(--neutralcolors-400);\n  box-shadow: 0px 0.735px 2.94px rgba(25, 33, 61, 0.08);\n  border-radius: 3px;\n  padding: 5px 8px;\n\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: 600;\n  font-size: 10.3px;\n  line-height: 15px;\n  color: var(--neutralcolors-700);\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n.scl--cms-components-careerChart-tooltipBeak {\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid var(--neutralcolors-400);\n}\n\n.scl--cms-components-careerChart-tooltipBeak::after {\n  content: '';\n  position: absolute;\n  top: -7px;\n  left: -5px;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--neutralcolors-100);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
